import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import defaultImage from './images/default-media.gif';

const Image = ({ className, src, alt, height, width, onError }) => {
  const [imagePath, setImagePath] = useState('');

  useEffect(() => {
    setImagePath(src);
  }, [src]);

  return (
    imagePath && (
      <img
        onContextMenu={(event) => {
          event.preventDefault();
          return false;
        }}
        className={className}
        src={imagePath}
        alt={alt}
        height={height}
        width={width}
        onError={() => {
          onError ? onError() : setImagePath(defaultImage);
        }}
      />
    )
  );
};

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  onError: PropTypes.func
};

export default Image;
